import React, { useState } from 'react';
import  { useEffect }from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "./redux/actions"
import FormGroup from '@mui/material/FormGroup';
import { APIvar } from '../services/variables';
import './TelefoniPRS.css'
import { componentStyles } from '../services/elementDesign'
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';

import Swal from 'sweetalert2';

const useColor = APIvar.colorUse;
const thirdColor = APIvar.colorTerciary;
const backColor = APIvar.colorBackground;
const cardBackColor = APIvar.cardBackgrounColor;

document.documentElement.style.setProperty('--backColor', backColor);
document.documentElement.style.setProperty('--cardBackColor', cardBackColor);


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});

const TelefoniPRS = () => {

    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const [mreza, setMreza] = useState('')
    const [selectedStatusOption, setSelectedStatusOption] = useState('');
    const [unio, setUnio] = useState('')
    const [primarnoDodijeljeno, setPrimarnoDodijeljeno] = useState('')
    const [dat, setDat] = useState('')
    const [odluka1, setOdluka1] = useState('')
    const [odluka2, setOdluka2] = useState('')
    const [selectedPrsOperatorOption, setSelectedPrsOperatorOption] = useState('');
    const [mb, setMb] = useState('')
    const [oib, setOib] = useState('')
    const [vlasnik, setVlasnik] = useState('')
    const [davateljUsluge, setDavateljUsluge] = useState('')
    const [nazivUsluge, setNazivUsluge] = useState('')
    const [komentarDaisy, setKomentarDaisy] = useState('')
    const [datumAkcije, setDatumAkcije] = useState('')
    const [selectedPortiranjeOption, setSelectedPortiranjeOption] = useState('');
    const [mjestoPRS, setMjestoPRS] = useState('')
    const [postaPRS, setPostaPRS] = useState('')
    const [ulicaPRS, setUlicaPRS] = useState('')
    const [kbrPRS, setKbrPRS] = useState('')
    const [slovoPRS, setSlovoPRS] = useState('')
    const [mjesto, setMjesto] = useState('')
    const [posta, setPosta] = useState('')
    const [ulica, setUlica] = useState('')
    const [kbr, setKbr] = useState('')
    const [slovo, setSlovo] = useState('')
    const [email, setEmail] = useState('')
    const [faks, setFaks] = useState('')
    const [telefon, setTelefon] = useState('')



    const [pregledArhiveIsVisible, setPregledArhiveIsVisible] = useState(false)
    const [pregledArhiveData,setPregledArhiveData] = useState([])

    const [upitiIzvjestaiIsVisible, setUpitiIzvjestaiIsVisible] = useState(false)

    //-----------------------
    const [prsOperatoriIsVisible, setPrsOperatoriIsVisible] = useState(false)
    //------------

    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)

    const customTheme = (outerTheme) =>
        createTheme({
          components: {
            MuiTextField: {
              styleOverrides: {
                root: {
                  '& label.Mui-focused': {
                    color: 'red',
                    top:"5px"
                  },
                },
              },
            },


          },
        });
        const outerTheme = useTheme();


useEffect(()=>{
        document.title="Val"
},[])


    const zadnjiBrojButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Zadnji broj")
        dispatch(actions.isNotLoading());
    }

    const OdlukeArhivaButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Odluke arhiva")
        dispatch(actions.isNotLoading());
    }

    const pdfButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Pdf")
        dispatch(actions.isNotLoading());
    }

    const primarnaDodjelaButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Primarna dodjela")
        dispatch(actions.isNotLoading());
    }

    const rezervacijeOduzimanjeButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Rezervacije oduzimanje")
        dispatch(actions.isNotLoading());
    }

    const pregledArhiveButtonFunction = () => {
        setPregledArhiveIsVisible(true)

        dispatch(actions.isLoading());
        console.log("Pregled arhive")
        dispatch(actions.isNotLoading());
    }

    const upitiButtonFunction = () => {
        setUpitiIzvjestaiIsVisible(true)

        dispatch(actions.isLoading());
        console.log("Upiti (f4)")
        dispatch(actions.isNotLoading());
    }

    const prsOperatoriButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("PRS Operatori")
        dispatch(actions.isNotLoading());
    }

    const odustaniButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Odustani")
        dispatch(actions.isNotLoading());
    }

    const snimiButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Snimi")
        dispatch(actions.isNotLoading());
    }

    const krajButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Kraj")
        dispatch(actions.isNotLoading());
    }


    const handleSelectStatusChange = (e) => {
        setSelectedStatusOption(e.target.value);
    };
    //MOCK DATA
    const statusOptions = [];

    const handleSelectPrsOperatorChange = (e) => {
        setSelectedPrsOperatorOption(e.target.value);
    };
    //MOCK DATA
    const prsOperatorOptions = [];

    const handleSelectPortiranjeChange = (e) => {
        setSelectedPortiranjeOption(e.target.value);
    };
    //MOCK DATA
    const portiranjeOptions = [];

    const staviObjavu = () => {
        //setChosenTKCRow(event.target.id);
        
     
    
        Swal.fire({
            title: `Unesite interval za oduzimanje`,
            text: "Početak i kraj intervala razdvojite znakom -",
            icon: "warning",
            iconSize: '5',
            input: "text",
            inputLabel: "",
            inputValue:'',
            showCancelButton: true,
            showCancelButton: true,
            confirmButtonColor: "#e31b2e",
            cancelButtonColor: "#29648a",
            showCancelButton: true,
            confirmButtonText: "Rezerviraj",
            cancelButtonText: "Odustani",
            denyButtonText: "Oduzmi",
            showDenyButton: true,
            denyButtonColor:'blue',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
    
                
    
            }
          });
        
    };
    


    return (
        <ThemeProvider theme={theme}>
            <div className='main-containerPRS'>

                     {/*  ---------------------- */}

                <Modal
                                        open={prsOperatoriIsVisible}
                                        onClose={()=> {
                                            setPrsOperatoriIsVisible(false)
                                        }}
                            >
                                <Box className="TelefoniPrs-modal-container"> 

                                    <Box className = "TelefoniPrs-modal-header">

                                        <Typography className="TelefoniPrs-header-title-text" variant="h6">
                                           Operatori
                                        </Typography>  
                                        

                                        <Box sx={{ display:"flex", flexDirection: "row", alignItems: "center", justifyContent:"center", gap:"20px"}}>
                                            <Grid container columns={12} spacing={1} > 

                                                    <Grid xs={5}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Traži po nazivu"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={2}>
                                                        <FormGroup>
                                                            <FormControlLabel sx={{ 
                                                                '& .MuiFormControlLabel-label': {fontSize: 12},
                                                               
                                                                }} 
                                                                control={<Checkbox   sx={{ 
                                                                '& .MuiSvgIcon-root': { fontSize: 12 }, 
                                                               
                                                                }}
                                                                 />} label="Novi Operator" />
                                                        </FormGroup>
                                                    </Grid>
                                                    <Grid xs={5}>
                                                        <Typography sx={{fontSize:12}}> 
                                                            Unesi dio naziva postojećeg operatora + ENTER (moguć zamjenski znak %). Za unos novoga kliknite na box "Novi operator
                                                        </Typography>
                                                    </Grid>


                                                    <Grid xs={10}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Naziv"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={2}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="ID"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>


                                                    <Grid xs={10}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Naziv agencijski"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>


                                                    <Grid xs={6}>
                                                    <FormControl variant="standard" sx={{ m: 1, width:'100%', margin:'0px' }}>
                                                            <InputLabel></InputLabel>
                                                            <Select
                                                                sx={{height:30}}
                                                                value={""}
                                                                label=""

                                                            
                                                            >
                                                                <MenuItem value="">
                                                                    <em></em>
                                                                </MenuItem>
                                                                
                                                                    <MenuItem key={1} value={"option"}>
                                                                        {"option"}
                                                                    </MenuItem>
                                                            
                                                            </Select>
                                                        </FormControl>                                                
                                                                                                            
                                                    </Grid>

                                                    <Grid xs={6}>
                                                    </Grid>

                                                    <Grid xs={5}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="MB/Registar"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={5}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="MB/Porezni"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={2}>

                                                        <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                                            Upute MB i OIB
                                                        </Button>  
                                                    </Grid>

                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="OIB"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Ime vlasnika"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>

                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="OIB2"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Ime vlasnika2"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    

                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="OIB3"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Ime vlasnika3"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>


                                                    <Grid xs={12}>
                                                        <FormGroup row sx={{ display:"flex", flexDirection: "row", alignItems: "center", justifyContent:"space-between"}}>
       
                                                            <FormControlLabel sx={{ 
                                                                '& .MuiFormControlLabel-label': {fontSize: 12},
                                                               
                                                                }} 
                                                                control={<Checkbox   sx={{ 
                                                                '& .MuiSvgIcon-root': { fontSize: 12 }, 
                                                               
                                                                }}
                                                                 />} label="Primarni Operator" />
                                                            <FormControlLabel sx={{ 
                                                                '& .MuiFormControlLabel-label': {fontSize: 12},
                                                               
                                                                }} 
                                                                control={<Checkbox   sx={{ 
                                                                '& .MuiSvgIcon-root': { fontSize: 12 }, 
                                                               
                                                                }}
                                                                 />} label="Operator javnij gov. usluga" />
                                                            <FormControlLabel sx={{ 
                                                                '& .MuiFormControlLabel-label': {fontSize: 12},
                                                               
                                                                }} 
                                                                control={<Checkbox   sx={{ 
                                                                '& .MuiSvgIcon-root': { fontSize: 12 }, 
                                                               
                                                                }}
                                                                 />} label="VAS-operator" />
                                                            <FormControlLabel sx={{ 
                                                                '& .MuiFormControlLabel-label': {fontSize: 12},
                                                               
                                                                }} 
                                                                control={<Checkbox   sx={{ 
                                                                '& .MuiSvgIcon-root': { fontSize: 12 }, 
                                                               
                                                                }}
                                                                 />} label="BIVSI Vas-op" />
                                                        </FormGroup>
                                                    </Grid>
                                                    

                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="KAM-Agent"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            
                                                    </Grid>



                                                    <Grid xs={6}>
                                                            <Typography sx={{fontSize:15}}> Sjedište PRS-operatora</Typography>
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            
                                                    </Grid>


                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Mjesto"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Posta"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>


                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Ulica"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={3}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Kbr"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={3}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Slovo"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>

                                                    <Grid xs={6}>
                                                            <Typography sx={{fontSize:15}}>Služba za podršku u korisnicima</Typography>
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            
                                                    </Grid>


                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Mjesto"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Posta"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>


                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Ulica"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={3}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Kbr"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={3}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Slovo"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>


                                                    <Grid xs={9}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="e-mail"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={3}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Faks"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>

                                                    <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="telefone"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                                    <Grid xs={6} sx={{fontSize:12,display:"flex", flexDirection: "row", alignItems: "center"}}>
                                                        <Typography sx={{fontSize:12}}> 
                                                            (mreža i telefon zajedno, bez razmaka i crtica)
                                                        </Typography>

                                                    </Grid>


                                                    <Grid xs={12}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                label="Komentar"
                                                                variant="outlined"
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                    </Grid>
                                            </Grid>
                                        </Box>
                                        <Box sx={{ display:"flex", flexDirection: "row", alignItems: "center", justifyContent:"center", gap:"20px"}}>

                                            <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                                Brisi
                                            </Button>  
                                            <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                                Upiti i Liste
                                            </Button>  
                                            
                                            <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                                Odustani
                                            </Button> 

                                            <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                                Snimi
                                            </Button> 
                                             
                                            
                                        </Box>

                

                                    </Box>
                                    <Box sx={{width:"100%", display:"none"}}>
                                        <TableContainer  sx={{ maxHeight: 350 }} component={Paper}>
                                            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                    
                                                        <TableCell sx={{fontWeight:600}}>Rbr</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Skriveno</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Tel/Blok</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Datum_akcije</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Rbr</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Vas Operator/Vlasnik</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Radni komentar</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Status(novi)</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Naziv Usluge(novi)</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">Stari Vas op</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                {pregledArhiveData.map((row) => (
                                                    <TableRow
                                                    key={row.rbr}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell sx={{fontWeight:600}}>{row.Rbr}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Skriveno}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Tel_Blok}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Datum_akcije}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Rbr}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Vas_Operator}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Radni_komentar}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Status_novi}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Naziv_usluge_novi}</TableCell>
                                                        <TableCell sx={{fontWeight:600}} align="right">{row.Stari_Vas_op}</TableCell>


                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    
                                    </Box>

                                </Box>
                </Modal>

                    {/*  ----------------------- */}

                <Modal
                                open={pregledArhiveIsVisible}
                                onClose={()=> {
                                    console.log(false)
                                    setPregledArhiveIsVisible(false)
                                }}
                    >
                        <Box className="TelefoniPrs-modal-container"> 

                            <Box className = "TelefoniPrs-modal-header">

                                <Typography className="TelefoniPrs-header-title-text" variant="h6">
                                    Pregled arhive
                                </Typography>  

                                <Box sx={{ display:"flex", flexDirection: "row", alignItems: "center", justifyContent:"center", gap:"20px"}}>

                                    <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                    Zadaj telefon
                                    </Button>  
                                    <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                        Skrivanje / Otkrivanje iz arhiva
                                    </Button>  
                                    
                                    <Button sx={{ height:"30px", fontSize: 11 }} variant="contained">
                                        Kraj
                                    </Button>  
                                    
                                </Box>

        

                            </Box>
                            <Box sx={{width:"100%"}}>
                                <TableContainer  sx={{ maxHeight: 350 }} component={Paper}>
                                    <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                            
                                                <TableCell sx={{fontWeight:600}}>Rbr</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Skriveno</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Tel/Blok</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Datum_akcije</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Rbr</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Vas Operator/Vlasnik</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Radni komentar</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Status(novi)</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Naziv Usluge(novi)</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Stari Vas op</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                        {pregledArhiveData.map((row) => (
                                            <TableRow
                                            key={row.rbr}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell sx={{fontWeight:600}}>{row.Rbr}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Skriveno}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Tel_Blok}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Datum_akcije}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Rbr}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Vas_Operator}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Radni_komentar}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Status_novi}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Naziv_usluge_novi}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Stari_Vas_op}</TableCell>


                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            
                            </Box>

                        </Box>
                </Modal>
                <Modal
                                open={upitiIzvjestaiIsVisible}
                                onClose={()=> {
                                    console.log(false)
                                    setUpitiIzvjestaiIsVisible(false)
                                }}
                    >
                        <Box className="TelefoniPrs-modal-container"> 

                            <Box className = "TelefoniPrs-modal-header">


                                <Typography className="TelefoniPrs-header-title-text" variant="h6">
                                    UPITI i izvještaji
                                </Typography>  
        

                            </Box>
                            


                                <Grid container columns={12} spacing={2} sx={{width:"100%", }}>

                                    <Grid xs={12}> 
                                     Zadajete jedno ili više ponuđenih polja. Zadajete cijeli tekst ili samo prvih nekoliko znakova nakon čega će vam biti ponuđene opcije koje zadovoljavaju vaš upit.
                                    </Grid>

                                    <Grid xs={6} container columns={12} spacing={1} > 
                                        <Grid xs={4} >
                                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Mreža i telefon"
                                                    variant="outlined"
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </Grid>
                                        <Grid xs={4} >
                                        <ThemeProvider theme={customTheme(outerTheme)}>
                                        <TextField label="Filled" variant="filled"
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            '&.label.Mui-focused': {
                                                            color: 'red',
                                                            top:"10px"
                                                            },
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label=""
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </ThemeProvider>
                                        </Grid>
                                        <Grid xs={4} >
                                            
                                            <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                                <InputLabel></InputLabel>
                                                <Select
                                                    sx={{height:30}}
                                                    value={""}
                                                    label=""

                                                    
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    
                                                        <MenuItem key={1} value={"option"}>
                                                            {"option"}
                                                        </MenuItem>
                                                 
                                                </Select>
                                            </FormControl>                                                
                                        </Grid>

                                        <Grid xs={12} >
                                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Naziv PRS OP"
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </Grid>

                                        <Grid xs={12} >
                                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Naziv usluge"
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </Grid>

                                        <Grid xs={8} >
                                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Napomena"
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </Grid>
                                        <Grid xs={4} >
                                            <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                                <InputLabel sx={{height:10,fontSize:"13px", display:"flex", alignItems:"center", justifyContent:"center", top:"7px"}}>Vrsta Brojeva</InputLabel>
                                                <Select
                                                    sx={{height:30}}
                                                    value={"Vrsta brojeva"}
                                                    label="Aktivnih u bloku"

                                                    
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    
                                                        <MenuItem key={1} value={"option"}>
                                                            
                                                        </MenuItem>
                                                    
                                                </Select>
                                            </FormControl>                                                


                                        </Grid>

                                        <Grid xs={6} >
                                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="MB"
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </Grid>
                                        <Grid xs={6} >
                                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="OIB"
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />
                                        </Grid>

                                        <Grid xs={6} >
                                        <FormControl variant="standard" sx={{ m: 1, width:'100%' , margin:'10px' }}>
                                                <InputLabel sx={{height:10,fontSize:"13px", display:"flex", alignItems:"center", justifyContent:"center", top:"7px"}}>Status</InputLabel>
                                                <Select
                                                    sx={{height:30}}
                                                    value={"Status"}
                                                    label="status"

                                                    
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    
                                                        <MenuItem key={1} value={"option"}>
                                                            {"option"}
                                                        </MenuItem>
                                                    
                                                </Select>
                                            </FormControl>                                                

                                        </Grid>
                                        <Grid xs={6} >
                                            <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="KAM"
                                                    variant="outlined"
                                                    
                                                    onChange={(event) => {
                                                        
                                                    }}
                                                />

                                        </Grid>

                                        <Grid xs={6} >
                                            <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                                <InputLabel sx={{height:10,fontSize:"13px", display:"flex", alignItems:"center", justifyContent:"center", top:"7px"}}>Vrsta Brojeva</InputLabel>
                                                <Select
                                                    sx={{height:30, fontSize:15}}
                                                    value={"option"}
                                                    label="Aktivnih u bloku"

                                                    
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    
                                                        <MenuItem key={1} value={"option"}>
                                                            
                                                        </MenuItem>
                                                    
                                                </Select>
                                            </FormControl>                                                
                                        </Grid>



                                    </Grid>

                                    <Grid xs={2} container columns={12} spacing={1}> 

                                        <Grid xs={12}>
                                            <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Traži</Button>
                                        </Grid>

                                        <Grid xs={12}>
                                            <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Poništi zadano</Button>
                                        </Grid>

                                        <Grid xs={12}>
                                            <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Izvoz u xlx datoteku</Button>
                                        </Grid>

                                        {/*<Grid xs={12}>
                                            <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Button</Button>
                                        </Grid>*/}

                                        {/*<Grid xs={12}>
                                            <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Button</Button>
                                        </Grid>*/}

                                    </Grid>

                                    <Grid xs={4} container columns={12} spacing={0}> 
                                        <Grid xs={6}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Po statusu</Button>
                                        </Grid>
                                        <Grid xs={6} sx={{ display:"flex", justifyContent:"flex-end"}}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>XLS</Button>
                                        </Grid>
                                        <Grid xs={6}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Prim. dodjela</Button>
                                        </Grid>
                                        <Grid xs={6} sx={{ display:"flex", justifyContent:"flex-end"}}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>XLS</Button>
                                        </Grid>
                                        <Grid xs={6}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Za agenciju</Button>
                                        </Grid>
                                        <Grid xs={6} sx={{ display:"flex", justifyContent:"flex-end"}}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>XLS</Button>
                                        </Grid>
                                        <Grid xs={6}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Prim. status</Button>
                                        </Grid>
                                        <Grid xs={6} sx={{ display:"flex", justifyContent:"flex-end"}}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>XLS</Button>
                                        </Grid>
                                        <Grid xs={6}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Iskorištenost</Button>
                                        </Grid>
                                        <Grid xs={6} sx={{ display:"flex", justifyContent:"flex-end"}}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>XLS</Button>
                                        </Grid>
                                        <Grid xs={6}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>Kvartal / operatori</Button>
                                        </Grid>
                                        <Grid xs={6} sx={{ display:"flex", justifyContent:"flex-end"}}>
                                                <Button  sx={{width:"95%", height:"30px", fontSize:11}}  variant="contained" onClick={()=> {}}>XLS</Button>
                                        </Grid>
                                        <Grid xs={12}>
                                                <Button  sx={{width:"100%", height:"30px"}}  variant="contained" onClick={()=> {}}>Kraj</Button>
                                        </Grid>

                                    </Grid>
                                    <Grid xs={12} container columns={12} spacing={2}>  
                                    
                                            <Grid xs={2} sx={{display:"flex", alignItems:"center"}}>
                                                <Button   sx={{width:"95%", height:"30px", display:"flex", alignItems:"center", fontSize:11}}  variant="contained" onClick={()=> {}}>Ispis cijele baze</Button>
                                            </Grid>
                                            <Grid xs={2}>
                                                <FormControl>
                                                    <FormLabel >Rezerv. Oduzimanje</FormLabel>
                                                    <RadioGroup
                                                        column
                                                        sx={{
                                                            
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 15,
                                                            },
                                                            }}
                                                    >
                                                        <FormControlLabel  value="samno-njih" control={<Radio />} label="Samo njih" />
                                                        <FormControlLabel value="samo-ciste" control={<Radio />} label="Samo čiste" />
                                                        <FormControlLabel value="sve" control={<Radio />} label="Sve" />

                                                    </RadioGroup>
                                                </FormControl>                                                    
                                            </Grid> 

                                            <Grid xs={2}>
                                                <FormControl>
                                                    <FormLabel >Primarna dodjela</FormLabel>
                                                    <RadioGroup
                                                        column
                                                        sx={{
                                                            
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 15,
                                                            },
                                                            }}
                                                    >
                                                        <FormControlLabel value="samo-ht" control={<Radio />} label="Samo HT" />
                                                        <FormControlLabel value="ostali" control={<Radio />} label="Ostali" />
                                                        <FormControlLabel value="svejedno" control={<Radio />} label="Svejedno" />

                                                    </RadioGroup>
                                                </FormControl>                                                    
                                            </Grid> 
                                            <Grid xs={2}>
                                                <FormControl>
                                                    <FormLabel>Sekundarna dodjela</FormLabel>
                                                    <RadioGroup
                                                        column
                                                        sx={{
                                                            
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 15,
                                                            },
                                                            }}
                                                    >
                                                        <FormControlLabel value="samo-ht" control={<Radio />} label="Samo HT" />
                                                        <FormControlLabel value="ostali" control={<Radio />} label="Ostali" />
                                                        <FormControlLabel value="svejedno" control={<Radio />} label="Svejedno" />

                                                    </RadioGroup>
                                                </FormControl>                                                    
                                            </Grid> 

                                                                                                
                                            <Grid xs={2}>

                                            </Grid> 
                                                                                                
                                            <Grid xs={2}>

                                            </Grid> 
                                                                                                
                                    </Grid>
                                </Grid>
                                

                            <Box sx={{width:"100%"}}>
                                <TableContainer  sx={{ maxHeight: 350 }} component={Paper}>
                                    <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                            
                                                <TableCell sx={{fontWeight:600}}>Rbr</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Skriveno</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Tel/Blok</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Datum_akcije</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Rbr</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Vas Operator/Vlasnik</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Radni komentar</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Status(novi)</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Naziv Usluge(novi)</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">Stari Vas op</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                        {pregledArhiveData.map((row) => (
                                            <TableRow
                                            key={row.rbr}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell sx={{fontWeight:600}}>{row.Rbr}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Skriveno}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Tel_Blok}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Datum_akcije}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Rbr}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Vas_Operator}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Radni_komentar}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Status_novi}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Naziv_usluge_novi}</TableCell>
                                                <TableCell sx={{fontWeight:600}} align="right">{row.Stari_Vas_op}</TableCell>


                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            
                            </Box>

                        </Box>
                </Modal>
                {/*FORMA*/}
                <div className='form-containerPRS'>

                    {/*Prvi box*/}
                    <div className='card-containerPRS'>

                        {/*Prvi red*/}
                        <div className='redContainerDivPRS'>
                            <div className='classForSpecificRowPrviDivPrviBox1PRS'>

                                <div style={{ width: '70%'  }}>
                                    <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                        fullWidth
                                        id="mreza_telefon"
                                        label="Mreža/Telefon"
                                        variant="outlined"
                                        value={mreza}
                                        onChange={(event) => {
                                            setMreza(event.target.value);
                                        }}
                                    />
                                </div>

                                <div style={{display: 'flex', alignContent: 'center', width: '30%' }}>
                                    <Button
                                        sx={{width:"95%", height:"30px", display:"flex", alignItems:"center", fontSize:11}}
                                        variant="contained" color="info"
                                        fullWidth
                                        onClick={() => {
                                            zadnjiBrojButtonFunction()
                                        }}
                                    //sx={componentStyles.prihvatiButtonStyle}
                                    >
                                        MEMO
                                    </Button>
                                </div>

                            </div>
                        </div>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <p style={{ color: 'grey' }}>
                                    (mreža i telefon zajedno, bez razmaka, a kratki kodovi počinju s KK)
                                </p>
                            </div>
                        </div>

                        {/*Drugi red*/}

                        <div className='redContainerDivPRS'>

                            <div className='classForSpecificRowDrugiDivPrviBox1PRS'>
                            <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                    <InputLabel id="status">Status</InputLabel>
                                    <Select
                                        labelId="status"
                                        id="status-select"
                                        value={selectedStatusOption}
                                        label="Status"
                                        onChange={handleSelectStatusChange}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {statusOptions.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='classForSpecificRowDrugiDivDrugiBox1PRS'>
                                <div style={{ width: '70%'  }}>
                                    <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                        fullWidth
                                        id="unio"
                                        label="Unio"
                                        variant="outlined"
                                        value={unio}
                                        onChange={(event) => {
                                            setUnio(event.target.value);
                                        }}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignContent: 'center', width: '30%' }}>
                                    <Button
                                      sx={{width:"95%", height:"30px", display:"flex", alignItems:"center", fontSize:11}}
                                     variant="contained" color="primary"
                                     fullWidth
                                        onClick={() => {
                                            OdlukeArhivaButtonFunction()
                                        }}
                                    //sx={componentStyles.prihvatiButtonStyle}
                                    >
                                        ODLUKE Arhiva
                                    </Button>
                                </div>
                            </div>



                        </div>


                        {/*Treci red*/}

                        <div className='redContainerDivPRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="primarnoDodijeljeno"
                                    label="Primarno dodijeljeno"
                                    variant="outlined"
                                    value={primarnoDodijeljeno}
                                    onChange={(event) => {
                                        setPrimarnoDodijeljeno(event.target.value);
                                    }}
                                />
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="dat"
                                    label="Dat"
                                    variant="outlined"
                                    value={dat}
                                    onChange={(event) => {
                                        setDat(event.target.value);
                                    }}
                                />
                               
                                    <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                        fullWidth
                                        id="odluka1"
                                        label="Odluka"
                                        variant="outlined"
                                        value={odluka1}
                                        onChange={(event) => {
                                            setOdluka1(event.target.value);
                                        }}
                                    />
                                    <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                        fullWidth
                                        id="odluka2"
                                        label=""
                                        variant="outlined"
                                        value={odluka2}
                                        onChange={(event) => {
                                            setOdluka2(event.target.value);
                                        }}
                                    />
                               

                                <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', width: '20%', marginLeft: '10px' }}>
                                    <Button sx={{ height:"30px", fontSize: 11 }}
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                            pdfButtonFunction()
                                        }}
                                    //sx={componentStyles.prihvatiButtonStyle}
                                    >
                                        PDF
                                    </Button>
                                </div>




                        </div>


                        {/*Opis 2*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <p style={{ color: 'grey' }}>
                                    (naziv firme i usluge se smiju pisati i malim slovima)
                                </p>
                            </div>
                        </div>

                        {/*Cetvrti red*/}

                        <div className='redContainerDivPRS'>

                            <div style={{ width: '100%' }}>
                            <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                    <InputLabel id="prs_operator">PRS-Operator</InputLabel>
                                    <Select
                                        labelId="prs_operator"
                                        id="prs_operator-select"
                                        value={selectedPrsOperatorOption}
                                        label="prs_operator"
                                        onChange={handleSelectPrsOperatorChange}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {prsOperatorOptions.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                        </div>


                        {/*Peti red*/}

                        <div className='redContainerDivPRS'>
                            <div className='classForSpecificRowPetiDivPrviBox1PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="mb"
                                    label="MB"
                                    variant="outlined"
                                    value={mb}
                                    onChange={(event) => {
                                        setMb(event.target.value);
                                    }}
                                />
                            </div>
                            <div className='classForSpecificRowPetiDivDrugiBox1PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="oib"
                                    label="OIB"
                                    variant="outlined"
                                    value={oib}
                                    onChange={(event) => {
                                        setOib(event.target.value);
                                    }}
                                />
                            </div>
                            <div className='classForSpecificRowPetiDivTreciBox1PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="vlasnik"
                                    label="Vlasnik"
                                    variant="outlined"
                                    value={vlasnik}
                                    onChange={(event) => {
                                        setVlasnik(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Sesti red*/}

                        <div className='redContainerDivPRS'>
                            <div style={{ width: '100%' }}>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="davateljUsluge"
                                    label="Davatelj usluge"
                                    variant="outlined"
                                    multiline
                                    value={davateljUsluge}
                                    onChange={(event) => {
                                        setDavateljUsluge(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Sedmi red*/}

                        <div className='redContainerDivPRS'>
                            <div style={{ width: '100%' }}>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="nazivUsluge"
                                    label="Naziv usluge"
                                    variant="outlined"
                                    multiline
                                    value={nazivUsluge}
                                    onChange={(event) => {
                                        setNazivUsluge(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Osmi red*/}

                        <div className='redContainerDivPRS'>
                            <div style={{ width: '100%' }}>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="komentarDaisy"
                                    label="Komentar Val"
                                    variant="outlined"
                                    multiline
                                    value={komentarDaisy}
                                    onChange={(event) => {
                                        setKomentarDaisy(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Deveti red*/}

                        <div className='redContainerDivPRS'>
                            <div className='classForSpecificRowDevetiDivDrugiBox1PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="datumAkcije"
                                    label="Datum akcije (uklj./isklj./prom./rezervacije)"
                                    variant="outlined"
                                    value={datumAkcije}
                                    onChange={(event) => {
                                        setDatumAkcije(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowDevetiDivTreciBox1PRS'>
                            <FormControl variant="standard" sx={{ m: 1, width:'100%', margin:'0px' }}>
                                    <InputLabel id="portiranje">Portiranje</InputLabel>
                                    <Select
                                        labelId="portiranje"
                                        id="portiranje-select"
                                        value={selectedPortiranjeOption}
                                        label="Portiranje"
                                        onChange={handleSelectPortiranjeChange}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {portiranjeOptions.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                        </div>




                    </div>

                    {/*Drugi box*/}
                    <div className='card-containerPRS'>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ fontWeight: 'bold' }}>
                                    Sjedište PRS-Operatora
                                </p>
                            </div>
                        </div>

                        {/*Prvi red*/}

                        <div className='redContainerDivPRS'>

                            <div className='classForSpecificRowPrviDivPrviBox2PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="mjestoPRS"
                                    label="Mjesto"
                                    variant="outlined"
                                    value={mjestoPRS}
                                    onChange={(event) => {
                                        setMjestoPRS(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowPrviDivDrugiBox2PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="postaPRS"
                                    label="Pošta"
                                    variant="outlined"
                                    value={postaPRS}
                                    onChange={(event) => {
                                        setPostaPRS(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Drugi red*/}

                        <div className='redContainerDivPRS'>

                            <div className='classForSpecificRowDrugiDivPrviBox2PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="ulicaPRS"
                                    label="Ulica"
                                    variant="outlined"
                                    value={ulicaPRS}
                                    onChange={(event) => {
                                        setUlicaPRS(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowDrugiDivDrugiBox2PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="kbrPRS"
                                    label="Kbr"
                                    variant="outlined"
                                    value={kbrPRS}
                                    onChange={(event) => {
                                        setKbrPRS(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowDrugiDivTreciBox2PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="slovoPRS"
                                    label="Slovo"
                                    variant="outlined"
                                    value={slovoPRS}
                                    onChange={(event) => {
                                        setSlovoPRS(event.target.value);
                                    }}
                                />
                            </div>

                        </div>



                    </div>

                    {/*Treci box*/}
                    <div className='card-containerPRS'>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ fontWeight: 'bold' }}>
                                    Služba za podršku korisnicima
                                </p>
                            </div>
                        </div>

                        {/*Prvi red*/}

                        <div className='redContainerDivPRS'>

                            <div className='classForSpecificRowPrviDivPrviBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="mjesto"
                                    label="Mjesto"
                                    variant="outlined"
                                    value={mjesto}
                                    onChange={(event) => {
                                        setMjesto(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowPrviDivDrugiBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="posta"
                                    label="Pošta"
                                    variant="outlined"
                                    value={posta}
                                    onChange={(event) => {
                                        setPosta(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Drugi red*/}

                        <div className='redContainerDivPRS'>

                            <div className='classForSpecificRowDrugiDivPrviBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="ulica"
                                    label="Ulica"
                                    variant="outlined"
                                    value={ulica}
                                    onChange={(event) => {
                                        setUlica(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowDrugiDivDrugiBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="kbr"
                                    label="Kbr"
                                    variant="outlined"
                                    value={kbr}
                                    onChange={(event) => {
                                        setKbr(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowDrugiDivTreciBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="slovo"
                                    label="Slovo"
                                    variant="outlined"
                                    value={slovo}
                                    onChange={(event) => {
                                        setSlovo(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Treci red*/}

                        <div className='redContainerDivPRS'>

                            <div className='classForSpecificRowTreciDivPrviBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="email"
                                    label="E-mail"
                                    variant="outlined"
                                    value={email}
                                    onChange={(event) => {
                                        setEmail(event.target.value);
                                    }}
                                />
                            </div>

                            <div className='classForSpecificRowTreciDivDrugiBox3PRS'>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="faks"
                                    label="Faks"
                                    variant="outlined"
                                    value={faks}
                                    onChange={(event) => {
                                        setFaks(event.target.value);
                                    }}
                                />
                            </div>

                        </div>


                        {/*Cetvrti red*/}

                        <div className='redContainerDivPRS'>

                            <div style={{ width: '100%' }}>
                                <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                    fullWidth
                                    id="telefon"
                                    label="Telefon"
                                    variant="outlined"
                                    value={telefon}
                                    onChange={(event) => {
                                        setTelefon(event.target.value);
                                    }}
                                />
                            </div>

                        </div>



                    </div>

                    {/*BOTUNI*/}
                    <div className='button-cardPRS'>
                        <div className='main-button-containerPRS'>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    disabled
                                    onClick={() => {
                                        primarnaDodjelaButtonFunction()
                                    }}
                                   
                                >
                                    Primarna Dodjela
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                color="error"
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        staviObjavu();

                                    }}
                                  
                                >
                                    Rezervacija / Oduzimanje
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        pregledArhiveButtonFunction()
                                    }}
                                    
                                >
                                    Pregled Arhive
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                color="info"
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        upitiButtonFunction()
                                    }}
                                  
                                >
                                    Upiti i izvještaji
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                            
                                    fullWidth
                                    variant="contained"
                                    disabled
                                    onClick={() => {
                                        prsOperatoriButtonFunction()
                                    }}
                                   
                                >
                                    PRS Operatori
                                </Button>
                            </div>
                        </div>

                        <div className='main-button-containerPRS'>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                color="error"
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        odustaniButtonFunction()
                                    }}
                                    
                                >
                                    ODUSTANI
                                </Button>
                            </div>

                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                color="success"
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        snimiButtonFunction()
                                    }}
                                    
                                >
                                    SNIMI
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                <Button sx={{ height:"30px", fontSize: 11 }}
                                color="error"
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        krajButtonFunction()
                                    }}
                                   
                                >
                                    KRAJ
                                </Button>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
        </ThemeProvider>


    );

};

export default TelefoniPRS;